import { useAppStore } from "@/global/store";
import {
  gameFiltersState,
  selectSectionSelected,
} from "@/global/store/data/gameFilters";
import { Box, Chip, Theme, darken, lighten, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";

export function SeatMap2dActionItems(props: { handleReset?: () => void }) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const styles = useStyles(theme);

  // filters state
  const selectedSection = useAppStore(selectSectionSelected);

  return (
    <Box p={1} sx={styles.wrapper}>
      {selectedSection ? (
        <Chip
          clickable
          color="default"
          variant="filled"
          onClick={props?.handleReset}
          label={"Clear Selection"}
          sx={styles.backButton}
        />
      ) : null}
    </Box>
  );
}

function useStyles(theme: Theme) {
  const paperBgColor = theme.palette.grey[300];

  return {
    wrapper: {
      position: "absolute",
      width: "fit-content",
      top: 0,
      left: 0,
      zIndex: 1,
    },
    backButton: {
      backgroundColor: paperBgColor,
      "&:hover": {
        backgroundColor: lighten(paperBgColor, 0.2),
      },
    },
  };
}
